import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { HistoryPointDto } from "../api/types.js";

interface Props {
  points: HistoryPointDto[];
  height?: number;
}

export function HistoryChart({ points, height = 240 }: Props) {
  const data = points.map((p) => ({
    ts: new Date(p.ts).getTime(),
    count: p.count,
    label: new Date(p.ts).toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
    }),
  }));

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(127,127,127,0.2)" />
        <XAxis
          dataKey="label"
          tick={{ fill: "var(--tg-hint)", fontSize: 11 }}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: "var(--tg-hint)", fontSize: 11 }}
          tickLine={false}
          width={48}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "var(--tg-bg-secondary)",
            border: "none",
            borderRadius: 8,
            color: "var(--tg-text)",
          }}
        />
        <Line
          type="monotone"
          dataKey="count"
          stroke="var(--tg-accent)"
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
